/* eslint no-unused-vars: 0 */

import React from 'react';

import { branchTermSingular } from 'utils/terminology';

class SiteSearchProductNoResults extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { query, assets, customerServicesEmail, b2bPhoneNumber } = this.props;
    return (
      <div className="products-no-results">
        <h3>
          Sorry, we couldn't find any search results matching{' '}
          <span>'{query}'</span>
        </h3>

        <hr />

        <h4>
          Please refine your search or alternatively contact our customer
          services team.
        </h4>

        <ul className="no-results-list">
          <li>
            <img src={assets.phone_red} className="icon" />
            You can also call <strong>{b2bPhoneNumber}</strong> to talk to an
            advisor.
            <br />
            Lines are open from 8am-8pm Monday-Friday.
          </li>
          <li>
            <img src={assets.chat_red} className="icon" />
            For immediate assistance please use our online chat.
            <br />
            Open from 8am-8pm Monday-Friday.
          </li>
          <li>
            <img src={assets.marker_red} className="icon" />
            If you would like to talk to someone in person.
            <br />
            Use our friendly {branchTermSingular} finder.
          </li>
          <li>
            <img src={assets.email_red} className="icon" />
            We are also contactable by email if your enquiry is out
            <br />
            of hours at{' '}
            <a href={`mailto:${customerServicesEmail}`}>
              <strong>{customerServicesEmail}</strong>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default SiteSearchProductNoResults;
